import { pickGenericEnemyCard } from './generic';
import type { EnemyAiDecision, EnemyAiDecisionContext } from './types';

export function pickDarkApostleCard(context: EnemyAiDecisionContext): EnemyAiDecision {
  return pickGenericEnemyCard(context);
}
